(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-media-carousel-pp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-dm-media-carousel]';

    const initCarousel = (root) => {
      if (!root || root.dataset.carouselReady === 'true') return;

      const track = root.querySelector('[data-carousel-track]');
      const cards = Array.from(root.querySelectorAll('[data-carousel-card]'));
      const prevButton = root.querySelector('[data-carousel-prev]');
      const nextButton = root.querySelector('[data-carousel-next]');

      if (!track || cards.length === 0) return;
      root.dataset.carouselReady = 'true';

      let frame = 0;
      let autoplayTimer = 0;
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayInterval = Number(root.dataset.interval) || 5000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const getActiveIndex = () => {
        const trackLeft = track.getBoundingClientRect().left;
        let activeIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateState = () => {
        const activeIndex = getActiveIndex();

        cards.forEach((card, index) => {
          const isActive = index === activeIndex;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (prevButton) prevButton.disabled = false;
        if (nextButton) nextButton.disabled = false;
      };

      const requestUpdate = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateState);
      };

      const scrollToCard = (index) => {
        const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
        const target = cards[targetIndex];
        if (!target) return;

        const trackRect = track.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const targetLeft = Math.max(
          0,
          Math.min(maxScroll, track.scrollLeft + targetRect.left - trackRect.left)
        );

        track.scrollTo({
          left: targetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      };

      const scrollByCard = (direction) => {
        let targetIndex = getActiveIndex() + direction;
        if (targetIndex < 0) targetIndex = cards.length - 1;
        if (targetIndex >= cards.length) targetIndex = 0;
        scrollToCard(targetIndex);
      };

      const scrollToStart = () => {
        scrollToCard(0);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = 0;
        }
      };

      const startAutoplay = () => {
        if (!autoplayEnabled || reduceMotion || cards.length < 2 || document.hidden) return;

        stopAutoplay();
        autoplayTimer = window.setInterval(() => {
          const current = getActiveIndex();
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

          if (track.scrollLeft >= maxScroll - 2 || current >= cards.length - 1) {
            scrollToStart();
          } else {
            scrollToCard(current + 1);
          }
        }, autoplayInterval);
      };

      prevButton?.addEventListener('click', () => scrollByCard(-1));
      nextButton?.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });

      root.addEventListener('pointerenter', stopAutoplay);
      root.addEventListener('pointerleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      updateState();
      startAutoplay();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(SELECTOR).forEach(initCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target.querySelector(SELECTOR);
      if (sectionRoot) initCarousel(sectionRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-home-pp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (!section || section.dataset.dmReliabilityReady === 'true') return;

      const track = section.querySelector('[data-dm-rel-track]');
      const cards = [...section.querySelectorAll('[data-dm-rel-card]')];
      const prev = section.querySelector('[data-dm-rel-prev]');
      const next = section.querySelector('[data-dm-rel-next]');
      const current = section.querySelector('[data-dm-rel-current]');

      if (!track || cards.length === 0) return;
      section.dataset.dmReliabilityReady = 'true';

      /* Native player controls own play/pause/fullscreen; only pause other cards. */
      cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;

        // Hide the browser's fullscreen button on players that support controlsList.
        video.setAttribute('controlslist', 'nofullscreen');
        if (video.controlsList && typeof video.controlsList.add === 'function') {
          video.controlsList.add('nofullscreen');
        }

        video.addEventListener('play', () => {
          cards.forEach((otherCard) => {
            if (otherCard === card) return;
            const otherVideo = otherCard.querySelector('video');
            if (otherVideo && !otherVideo.paused) otherVideo.pause();
          });
        });
      });

      const updateMobileState = () => {
        if (window.innerWidth > 749) return;
        const trackRect = track.getBoundingClientRect();
        let activeIndex = 0;
        let minDistance = Infinity;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
        if (prev) prev.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === cards.length - 1;
      };

      const scrollToCard = (index) => {
        const clamped = Math.max(0, Math.min(cards.length - 1, index));
        cards[clamped]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      prev?.addEventListener('click', () => {
        const active = Math.max(0, cards.findIndex((card) => {
          const trackRect = track.getBoundingClientRect();
          return Math.abs(card.getBoundingClientRect().left - trackRect.left) < 12;
        }));
        scrollToCard(active - 1);
      });

      next?.addEventListener('click', () => {
        const trackRect = track.getBoundingClientRect();
        let active = 0;
        let minDistance = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            active = index;
          }
        });
        scrollToCard(active + 1);
      });

      track.addEventListener('scroll', () => requestAnimationFrame(updateMobileState), { passive: true });
      window.addEventListener('resize', updateMobileState, { passive: true });
      requestAnimationFrame(updateMobileState);
    };

    const initAll = (root = document) => {
      if (root.matches?.('[data-dm-reliability]')) initSection(root);
      root.querySelectorAll?.('[data-dm-reliability]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase-pp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (!section || section.dataset.dmReliabilityReady === 'true') return;

      const track = section.querySelector('[data-dm-rel-track]');
      const cards = [...section.querySelectorAll('[data-dm-rel-card]')];
      const prev = section.querySelector('[data-dm-rel-prev]');
      const next = section.querySelector('[data-dm-rel-next]');
      const current = section.querySelector('[data-dm-rel-current]');

      if (!track || cards.length === 0) return;
      section.dataset.dmReliabilityReady = 'true';

      /* Native player controls own play/pause/fullscreen; only pause other cards. */
      cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;

        // Hide the browser's fullscreen button on players that support controlsList.
        video.setAttribute('controlslist', 'nofullscreen');
        if (video.controlsList && typeof video.controlsList.add === 'function') {
          video.controlsList.add('nofullscreen');
        }

        video.addEventListener('play', () => {
          cards.forEach((otherCard) => {
            if (otherCard === card) return;
            const otherVideo = otherCard.querySelector('video');
            if (otherVideo && !otherVideo.paused) otherVideo.pause();
          });
        });
      });

      const updateMobileState = () => {
        if (window.innerWidth > 749) return;
        const trackRect = track.getBoundingClientRect();
        let activeIndex = 0;
        let minDistance = Infinity;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
        if (prev) prev.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === cards.length - 1;
      };

      const scrollToCard = (index) => {
        const clamped = Math.max(0, Math.min(cards.length - 1, index));
        cards[clamped]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      prev?.addEventListener('click', () => {
        const active = Math.max(0, cards.findIndex((card) => {
          const trackRect = track.getBoundingClientRect();
          return Math.abs(card.getBoundingClientRect().left - trackRect.left) < 12;
        }));
        scrollToCard(active - 1);
      });

      next?.addEventListener('click', () => {
        const trackRect = track.getBoundingClientRect();
        let active = 0;
        let minDistance = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            active = index;
          }
        });
        scrollToCard(active + 1);
      });

      track.addEventListener('scroll', () => requestAnimationFrame(updateMobileState), { passive: true });
      window.addEventListener('resize', updateMobileState, { passive: true });
      requestAnimationFrame(updateMobileState);
    };

    const initAll = (root = document) => {
      if (root.matches?.('[data-dm-reliability]')) initSection(root);
      root.querySelectorAll?.('[data-dm-reliability]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
